
import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const FETCH_PARK_DETAILS_REQUEST = "FETCH_PARK_DETAILS_REQUEST";
export const FETCH_PARK_DETAILS_SUCCESS = "FETCH_PARK_DETAILS_SUCCESS";
export const FETCH_PARK_DETAILS_FAILURE = "FETCH_PARK_DETAILS_FAILURE";

export const UPDATE_PARK_DETAILS_REQUEST = "UPDATE_PARK_DETAILS_REQUEST";
export const UPDATE_PARK_DETAILS_SUCCESS = "UPDATE_PARK_DETAILS_SUCCESS";
export const UPDATE_PARK_DETAILS_FAILURE = "UPDATE_PARK_DETAILS_FAILURE";

export const fetchParkDetails = (params = {}) => {
  const {
    page = 1,
    limit = 20,
    project_type = "",
    district = "",
    municipality = "",
    search = "",
  } = params;

  return async (dispatch) => {
    dispatch({ type: FETCH_PARK_DETAILS_REQUEST });

    const token = localStorage.getItem("token");

    try {
      const res = await axios.get(`${BASE_URL}/v1/api/admin/park_details`, {
        params: { page, limit, project_type, district, municipality, search },
        headers: { authorization: token },
      });

      const meta = res.data.meta || {};

      dispatch({
        type: FETCH_PARK_DETAILS_SUCCESS,
        payload: {
          data: res.data.data,
          pagination: {
            currentPage: meta.page || 1,
            totalPages: meta.totalPages || 1,
            totalItems: meta.total || 0,
            limit: meta.limit || limit,
          },
        },
      });
    } catch (err) {
      dispatch({
        type: FETCH_PARK_DETAILS_FAILURE,
        payload: err.response?.data?.message || "Failed to load",
      });
    }
  };
};

export const updateParkDetails = (id, updatedData) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_PARK_DETAILS_REQUEST });

    const token = localStorage.getItem("token");

    try {
      const res = await axios.put(
        `${BASE_URL}/v1/api/admin/park_details/${id}`,
        updatedData,
        {
          headers: {
            authorization: token,
            "Content-Type": "application/json",
          },
        }
      );

      dispatch({
        type: UPDATE_PARK_DETAILS_SUCCESS,
        payload: res.data.data,
      });

      toast.success("Updated Successfully");

      return res.data;
    } catch (err) {
      dispatch({
        type: UPDATE_PARK_DETAILS_FAILURE,
        payload: err.response?.data?.message || "Update failed",
      });

      toast.error(err.response?.data?.message || "Failed to update");

      throw err;
    }
  };
};
